import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { error } from 'console';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';

type UserPublicRegisterBody = {
  cpf: string;
  name: string;
  email: string;
  password: string;
  passwordConfirm: string;
};

@Injectable({
  providedIn: 'root',
})
export class UserPublicV2Service {
  url = `${environment.api_v2}/v2/user-public`;

  constructor(
    private readonly http: HttpClient,
    private readonly loginService: LoginService
  ) {}

  public register(
    body: UserPublicRegisterBody,
    token: string
  ): Observable<void> {
    return this.http
      .post<void>(`${this.url}/register`, body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .pipe(
        catchError((error) => {
          this.loginService.showMessage(error.error.message);
          return throwError(() => error);
        })
      );
  }

  public validateToken(token: string) {
    return this.http
      .get<boolean>(`${this.url}/register/validate-token`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .pipe(
        catchError((error) => {
          this.loginService.showMessage(error.message);
          return throwError(() => error);
        })
      );
  }
}
